var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "siteBox" },
    [
      _c(
        "div",
        { staticClass: "crumbs" },
        [
          _c("img", {
            staticClass: "a1",
            attrs: { src: require("@/assets/newicons/i001.png"), alt: "" },
            on: {
              click: function ($event) {
                return _vm.$router.go(-1)
              },
            },
          }),
          _c("span", { staticStyle: { "margin-right": "10px" } }, [
            _vm._v("返回"),
          ]),
          _c("el-divider", { attrs: { direction: "vertical" } }),
          _c("span", { staticStyle: { "margin-left": "10px" } }, [
            _vm._v("代码安装说明"),
          ]),
        ],
        1
      ),
      _c("div", { staticClass: "code-content" }, [
        _c("h1", [_vm._v("如何安装臻寻客识别跟踪代码")]),
        _c("p", { staticStyle: { "font-size": "13px" } }, [
          _vm._v(
            "客户要使用臻寻客识别各种功能，需要先在自己的网站上部署臻寻客识别的js识别代码。 js识别代码部署步骤比较简单，只需要将以下说明和代码，交付给公司网站web/h5页面的开发工程师即可。"
          ),
        ]),
        _c(
          "p",
          { staticClass: "explain", staticStyle: { "font-size": "13px" } },
          [_vm._v("部署识别代码说明：")]
        ),
        _c(
          "ul",
          { staticClass: "codeList", staticStyle: { "font-size": "13px" } },
          [
            _c("li", [
              _vm._v(
                "1.将以下javascript代码插入到网站页面的" +
                  _vm._s(_vm.interhtml) +
                  "标签前。如还使用了其他统计代码，请将臻寻客识别代码部署在其他代码之前。 "
              ),
            ]),
            _c("li", [
              _vm._v(
                "2.如果您网站有统一调用的网站头部模版，请在head.html的类似页头模板页面中安装，以达到一处安装，全站皆有的效果。如果站点没有此类统一调用的头部模版，就建议每一页都安装上代码，以达到全站检测的效果。"
              ),
            ]),
            _c("li", [
              _vm._v(
                "3.如需在独立js文件中引入臻寻客识别代码，请直接去掉以下代码首尾的" +
                  _vm._s(_vm.interhtml1) +
                  " 与" +
                  _vm._s(_vm.interhtml2) +
                  "后，放入js文件中即可。"
              ),
            ]),
            _c("li", [
              _vm._v(
                "部署完成后，请进行代码检测，只有检测成功了，臻寻客识别相关功能就可以正常使用了。"
              ),
            ]),
          ]
        ),
        _c(
          "div",
          {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.loading,
                expression: "loading",
              },
            ],
            staticClass: "copyarea",
          },
          [_vm._v(_vm._s(_vm.content))]
        ),
      ]),
      _c("setDrawer", { ref: "setDrawer" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }